// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCanVX86C5GiLXqmBGRIhNJjiByrS2_J2M",
  authDomain: "tulsiott.firebaseapp.com",
  projectId: "tulsiott",
  storageBucket: "tulsiott.appspot.com",
  messagingSenderId: "505535435832",
  appId: "1:505535435832:web:b9abc258c54913497982cd",
  measurementId: "G-NHEG3W79D8",
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getStorage(app);
